import { API_BASE } from '../../constants';
import { makeHttpGet } from '../';
import { SheetFundSeriesUseCase } from '../../usecases';
import {
  createComparisonDrawDownSerie,
  createSheetFundNetWorthSerieChart,
  createSheetFundsQuotaHoldersSerieChart,
  createComparisonVolatilitySerie,
  createProfitSeries,
} from '../../helpers';
import { IFundQuotes } from '../../interfaces';

export const makeSheetFundSeries = () => {
  const url = `${API_BASE}/funds/quotes`;
  const httpGet = makeHttpGet<IFundQuotes>();

  return new SheetFundSeriesUseCase(
    url,
    httpGet,
    createSheetFundNetWorthSerieChart,
    createSheetFundsQuotaHoldersSerieChart,
    createComparisonDrawDownSerie,
    createComparisonVolatilitySerie,
    createProfitSeries
  );
};
